// extracted by mini-css-extract-plugin
export var blink = "_003-input-and-form-module--blink--Xf7bw";
export var modalSvg = "_003-input-and-form-module--modalSvg--1FQEq";
export var modalSvgContainer = "_003-input-and-form-module--modalSvgContainer--2BbP8";